export default "__VITE_ASSET__CSRcyo6m__"